import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGenderMale: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGenderMale"><Path fillRule="evenodd" clipRule="evenodd" d="M14 3H21V10H19V6.41421L14.2489 11.1653C15.0356 12.2403 15.5 13.5659 15.5 15C15.5 18.5899 12.5899 21.5 9 21.5C5.41015 21.5 2.5 18.5899 2.5 15C2.5 11.4101 5.41015 8.5 9 8.5C10.4341 8.5 11.7597 8.96443 12.8347 9.7511L17.5858 5H14V3ZM9 10.5C6.51472 10.5 4.5 12.5147 4.5 15C4.5 17.4853 6.51472 19.5 9 19.5C11.4853 19.5 13.5 17.4853 13.5 15C13.5 12.5147 11.4853 10.5 9 10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGenderMale;
